import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { InfoCircleOutlineIcon } from "@cmsgov/ds-medicare-gov";
import { AppContext } from "../../app/store";
import { useTranslate } from "../../helpers";
import { HelpDrawerWrapper } from "../../components";
import { newBasicHelperDrawerAnalytics } from "../BasicHelperDrawerAnalytics";
import {
  AnalyticsActionType,
  Ga4Event,
  Ga4EventType,
} from "../../app/contexts/Analytics/types";
import routes from "../../app/routes";

export interface PlanTypeHelpDrawerProps {
  newToMedicare?: boolean;
}
export const PlanTypeHelpDrawer: React.FC<PlanTypeHelpDrawerProps> = ({
  newToMedicare,
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  const helpDrawerToggleText = t("coverage_selector.help_drawer.toggle");
  const helpDrawerTitle = t("coverage_selector.help_drawer.title");
  const needHelpText = newToMedicare
    ? t("coverage_selector.ntm.help_link_text")
    : t("coverage_selector.help_drawer.help_link_text");
  const needHelpLinkUrl = routes.coverageWizard.options;
  const helperDrawerAnalytics = newBasicHelperDrawerAnalytics({
    customGA4OpenSettings: {
      event_name: Ga4Event.HELP_DRAWER_OPENED,
      event_type: Ga4EventType.UI_INTERACTION,
      heading: helpDrawerTitle,
      text: helpDrawerToggleText,
    },
    customGA4CloseSettings: {
      event_name: Ga4Event.HELP_DRAWER_CLOSED,
      event_type: Ga4EventType.UI_INTERACTION,
      heading: helpDrawerTitle,
    },
    customTealiumOpenSettings: {
      event_action: "help drawer opened",
      event_label: helpDrawerTitle,
      event_category: "ui interaction",
    },
    customTealiumCloseSettings: {
      event_action: "help drawer closed",
      event_label: helpDrawerTitle,
      event_category: "ui interaction",
    },
    dispatch,
  });
  return (
    <HelpDrawerWrapper
      toggleText={
        <>
          <span className="ds-u-margin-right--1">{helpDrawerToggleText}</span>
          <InfoCircleOutlineIcon />
        </>
      }
      toggleClassName="mct-c-coverage-selector-v2__help-drawer-toggle"
      mctAnalytics={helperDrawerAnalytics}
      drawerTitle={helpDrawerTitle}
    >
      <div>
        {/** // * Medicare Advantage Plan (Part C) */}
        <h4 className="ds-u-margin-bottom--0">
          {t("coverage_selector.help_drawer.part_c.sub_heading")}
        </h4>
        <p className="ds-u-margin-top--1">
          {t("coverage_selector.help_drawer.part_c.body")}
        </p>
        {/** // * Medicare drug plan (Part D) */}
        <h4 className="ds-u-margin-bottom--0">
          {t("coverage_selector.help_drawer.part_d.sub_heading")}
        </h4>
        <p className="ds-u-margin-top--1">
          {t("coverage_selector.help_drawer.part_d.body")}
        </p>
        {/** // * Medigap policy */}
        <h4 className="ds-u-margin-bottom--0">
          {t("coverage_selector.help_drawer.medigap.sub_heading")}
        </h4>
        <p className="ds-u-margin-top--1">
          {t("coverage_selector.help_drawer.medigap.body")}
        </p>
        <Link
          to={needHelpLinkUrl}
          onClick={() => {
            dispatch({
              type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
              settings: {
                linkText: needHelpText,
                linkUrl: needHelpLinkUrl,
              },
            });
          }}
        >
          {needHelpText}
        </Link>
      </div>
    </HelpDrawerWrapper>
  );
};
